<template>
  <gj-popover
    v-model="visible"
    placement="top"
    title="结束日期"
    width="200"
    lazy
    trigger="manual"
    @show="popoverShow">
    <div class="gj-cell-display-switch" slot="reference" @click="showEdit()" v-if="isEdit">
      <i class="el-icon-edit"></i>
    </div>
    <el-form ref="form" :model="form">
      <el-form-item>
        <gj-date-picker
        v-model="form.endDate"
        width="200px"
        :editable="false"
        :disabled-date="disabledEndDate"
    ></gj-date-picker>
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin-top: 14px">
      <gj-button :size="'mini'" @click="close()">取消</gj-button>
      <gj-button :size="'mini'" type="primary" @click="confirm()" :loading="loading" >确定</gj-button>
    </div>
  </gj-popover>
</template>

<script>
  import { formRuleMixin } from "@/minxins";
  import { disabledEndDate } from "@/utils/common";
export default {
  name: "ad-edit-dateEnd",
  mixins: [formRuleMixin],
  props: {
    value: {},
    isEdit: {
      type: Boolean,
      default: true
    },
    updateValue: {
        type: Function
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      disabledEndDate: disabledEndDate(new Date()),
      form: {
        endDate: null
      }
    };
  },
  components: {},
  methods: {
    popoverShow() {
      this.form.endDate = this.value.endDate;
    },
    close() {
      this.visible = false
    },
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false;
        this.loading = true;
        try {
          const data = await this.updateValue(this.form.endDate, this.value);
          this.visible = data;
        } finally {
          this.loading = false;
        }
      });
      
    },
    showEdit() {
      this.visible = true
    },
  },
};
</script>

<style scoped lang='scss'>
.el-icon-edit {
  font-size: 13px;
}
/deep/ .el-popover {
  padding: 16PX !important;
}
</style>